export enum ActionType {
	LOGIN = "LOGIN",
	LOGOUT = "LOGOUT",
	ADD_URL = "ADD_URL",
	VERIFY_OTP = "VERIFY_OTP",
	ERROR = "ERROR",
	LOADING = "LOADING",
	NOT_LOADING = "NOT_LOADING",
	SET_MEDIUM = "SET_MEDIUM",
	SET_SHARED = "SET_SHARED",
}

export enum DataActionType {
	UPDATE_DATA = "UPDATE_DATA",
}

export enum SnackbarActionType {
	SET_SNACK = "SET_SNACK",
	UNSET_SNACK = "UNSET_SNACK",
}

// export const BACKEND_URL = "https://api.webmark.tech"
export const BACKEND_URL = process.env.REACT_APP_API_URL
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL
// export const BACKEND_URL = "http://localhost:3001";
// export const FRONTEND_URL = "http://localhost:3000";